import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { userService } from '../../../services/userService';

const UserDeleteModal = ({ user, onConfirm, onCancel }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleDelete = async () => {
    setLoading(true);
    try {
      await userService?.deleteUser(user?.id);
      onConfirm(user?.id);
    } catch (error) {
      console.error('Error deleting user:', error);
      setError('Failed to delete user. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-card border border-border rounded-lg shadow-lg w-full max-w-md">
        <div className="p-6">
          <div className="flex items-center space-x-3 mb-4">
            <div className="p-2 bg-destructive/10 rounded-lg">
              <Icon name="AlertTriangle" className="text-destructive" size={24} />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-foreground">Delete User</h3>
              <p className="text-sm text-muted-foreground">This action cannot be undone</p>
            </div>
          </div>

          <div className="bg-muted/50 rounded-lg p-4 mb-6">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-muted rounded-full flex items-center justify-center">
                {user?.avatar_url ? (
                  <img 
                    src={user?.avatar_url} 
                    alt={user?.full_name} 
                    className="w-10 h-10 rounded-full object-cover"
                  />
                ) : (
                  <Icon name="User" size={20} className="text-muted-foreground" />
                )}
              </div>
              <div>
                <div className="font-medium text-foreground">{user?.full_name}</div>
                <div className="text-sm text-muted-foreground">{user?.email}</div>
              </div>
            </div>
          </div>

          <div className="mb-6">
            <p className="text-sm text-foreground mb-2">
              Are you sure you want to delete this user? This will:
            </p>
            <ul className="text-sm text-muted-foreground space-y-1 ml-4">
              <li>• Permanently remove their account</li>
              <li>• Delete all associated data</li>
              <li>• Remove them from all collections</li>
              <li>• Cannot be undone</li>
            </ul>
          </div>

          {error && (
            <div className="mb-4 p-3 bg-destructive/10 border border-destructive/20 rounded-lg">
              <p className="text-sm text-destructive">{error}</p>
            </div>
          )}

          <div className="flex items-center justify-end space-x-3">
            <Button
              type="button"
              variant="outline"
              onClick={onCancel}
              disabled={loading}
            >
              Cancel
            </Button>
            <Button
              type="button"
              variant="destructive"
              onClick={handleDelete}
              loading={loading}
            >
              Delete User
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDeleteModal;